/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { order } from "../../../../api/Api";

export const getAllSumUp = createAsyncThunk(
  "appSumUp/getAllSumUp",
  async (values) => {
    try {
      return order.getSumUp(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllSumUpForAll = createAsyncThunk(
  "appSumUp/getAllSumUpForAll",
  async (values) => {
    try {
      return order.getSumUpForAll(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const appSumUpSlice = createSlice({
  name: "appSumUp",
  initialState: {
    sumUp: [],
    sumUpFetch: false,
    sumUpForAll: [],
    sumUpForAllFetch: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllSumUp.fulfilled, (state, action) => {
        state.sumUp = action.payload?.data?.data;
        state.sumUpFetch = true;
      })
      .addCase(getAllSumUpForAll.fulfilled, (state, action) => {
        state.sumUpForAll = action.payload?.data?.data;
        state.sumUpForAllFetch = false;
      });
  },
});

export default appSumUpSlice.reducer;
